import { shipToSelectorStyles as styles } from "@insite/content-library/Components/ShipToSelector";
import { css } from "styled-components";


styles.customerSelector = {
    customerCard: {
        editLink: {
            css: css`
                display: none;
            `,
        },
    },
};
